export enum RemoteMfeNames {
	AccountManagementUI = 'account-management-ui',
	ImageHub = 'image-hub',
	ConnectionManagementUI = 'con-mgmt-ui',
}

/**
 * Fragment appIds for UI fragments embedded inside MIFL via sl-embedded-remote-application.
 * Format: '<mfe-name>/<webpack-expose-name>'
 */
export enum RemoteMfeFragments {
	ConMgmtUiSettingsTab = 'con-mgmt-ui/mifl-settings-tab',
}
